export const tune=`<?xml version="1.0" encoding="ISO-8859-1"?>
<msq xmlns="http://www.msefi.com/:msq">
    <bibliography author="TunerStudio MS Ultra(Beta) 3.1.08.31 - EFI Analytics, Inc." tuneComment="" writeDate="Sat Feb 10 17:07:19 GMT 2024"/>
    <versionInfo fileFormat="5.0" firmwareInfo="Speeduino+202207.1" nPages="15" signature="speeduino 202207"/>
    <page>
        <pcVariable name="tsCanId">"CAN ID 0"</pcVariable>
        <pcVariable digits="0" name="rpmhigh" units="rpm">6000.0</pcVariable>
        <pcVariable digits="0" name="rpmwarn" units="rpm">4000.0</pcVariable>
        <pcVariable digits="0" name="rpmdang" units="rpm">5000.0</pcVariable>
        <pcVariable digits="0" name="maphigh" units="kPa">255.0</pcVariable>
        <pcVariable digits="0" name="mapwarn" units="kPa">200.0</pcVariable>
        <pcVariable digits="0" name="mapdang" units="kPa">245.0</pcVariable>
        <pcVariable digits="1" name="batlow" units="Volts">11.8</pcVariable>
        <pcVariable digits="1" name="bathigh" units="Volts">15.0</pcVariable>
        <pcVariable cols="1" digits="3" name="wueAFR" rows="10" units="Lambda">
         -0.1360544 
         -0.1020408 
         -0.0816327 
         -0.0680272 
         -0.0544218 
         -0.0408163 
         -0.0272109 
         -0.0136054 
         -0.0068027 
         0.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="wueRecommended" rows="10" units="%">
         193.0 
         175.0 
         152.0 
         130.0 
         115.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardFuelOutputs" rows="128" units=" ">
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         6.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardIgnOutputs" rows="128" units=" ">
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         6.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardHasRTC" rows="128" units=" ">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         6.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         1.0 
         0.0 
         0.0 
         0.0 
         0.0 
         8.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="algorithmLimits" rows="8">
         511.0 
         100.0 
         511.0 
         511.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </pcVariable>
        <pcVariable name="prgm_out_selection">"4"</pcVariable>
        <pcVariable digits="0" name="fuelLoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="ignLoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="fuel2LoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="ign2LoadMax">255.0</pcVariable>
        <pcVariable name="AUXin00Alias">Aux0</pcVariable>
        <pcVariable name="tsSpeedSource">"GPS Speed"</pcVariable>
        <pcVariable digits="0" name="tsPrimaryInjectorSize">0.0</pcVariable>
        <pcVariable name="tsInjSizeConstant">"cc/min"</pcVariable>
        <pcVariable name="tsLogPowerFields">"Log HP &amp; Tq"</pcVariable>
        <pcVariable name="tsLogPerfFields">"Off"</pcVariable>
        <pcVariable name="tsFuelConsumptionUnits">"US Gallons"</pcVariable>
        <pcVariable name="tsDistanceUnits">"Miles Per Hour"</pcVariable>
        <pcVariable digits="0" name="tsVehicleWeight">3450.0</pcVariable>
        <pcVariable name="tsWeightUnits">"lbs"</pcVariable>
        <pcVariable digits="2" name="tsVehicleDragCoef">0.34</pcVariable>
        <pcVariable digits="0" name="tsTirePressure" units="psi">32.0</pcVariable>
        <pcVariable digits="1" name="tsFrontalArea">19.3</pcVariable>
        <pcVariable name="tsFrontalUnits">"sqft"</pcVariable>
        <pcVariable digits="1" name="tsTireDiameter" units="in">25.5</pcVariable>
        <pcVariable digits="2" name="tsTransGearRatio" units=":1">1.0</pcVariable>
        <pcVariable digits="2" name="tsFinalDriveRatio" units=":1">3.7</pcVariable>
        <pcVariable digits="0" name="tsEtRollOut" units="in">0.0</pcVariable>
    </page>
    <page number="0" size="128">
        <constant digits="1" name="aseTaperTime" units="S">10.0</constant>
        <constant digits="0" name="aeColdPct" units="%">100.0</constant>
        <constant digits="0" name="aeColdTaperMin" units="C">0.0</constant>
        <constant name="aeMode">"TPS"</constant>
        <constant name="battVCorMode">"Open Time only"</constant>
        <constant name="SoftLimitMode">"Fixed"</constant>
        <constant name="useTachoSweep">"On"</constant>
        <constant name="aeApplyMode">"PW Multiplier"</constant>
        <constant name="multiplyMAP">"Off"</constant>
        <constant cols="1" digits="0" name="wueRates" rows="10" units="%">
         193.0 
         175.0 
         152.0 
         130.0 
         115.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
        <constant digits="0" name="crankingPct" units="%">20.0</constant>
        <constant name="pinLayout">"DIY-EFI CORE4 v1.0"</constant>
        <constant name="tachoPin">"Board Default"</constant>
        <constant name="tachoDiv">"Normal"</constant>
        <constant digits="0" name="tachoDuration" units="ms">1.0</constant>
        <constant digits="0" name="maeThresh" units="kPa/s">70.0</constant>
        <constant digits="0" name="taeThresh" units="%/s">70.0</constant>
        <constant digits="0" name="aeTime" units="ms">200.0</constant>
        <constant name="display">"Unused"</constant>
        <constant name="display1">"VE"</constant>
        <constant name="display2">"CPU"</constant>
        <constant name="display3">"TPS"</constant>
        <constant name="display4">"Mem"</constant>
        <constant name="display5">"RPM"</constant>
        <constant name="displayB1">"RPM"</constant>
        <constant name="displayB2">"RPM"</constant>
        <constant digits="1" name="reqFuel" units="ms">10.0</constant>
        <constant digits="0" name="divider">2.0</constant>
        <constant name="alternate">"Simultaneous"</constant>
        <constant name="multiplyMAP1">"No"</constant>
        <constant name="includeAFR">"No"</constant>
        <constant name="hardCutType">"Rolling"</constant>
        <constant name="ignAlgorithm">"TPS"</constant>
        <constant name="indInjAng">"Enabled"</constant>
        <constant digits="1" name="injOpen" units="ms">1.0</constant>
        <constant cols="1" digits="0" name="injAng" rows="4" units="deg">
         355.0 
         355.0 
         355.0 
         355.0 
      </constant>
        <constant name="mapSample">"Cycle Average"</constant>
        <constant name="twoStroke">"Four-stroke"</constant>
        <constant name="injType">"Throttle Body"</constant>
        <constant name="nCylinders">"8"</constant>
        <constant name="algorithm">"TPS"</constant>
        <constant name="fixAngEnable">"Off"</constant>
        <constant name="nInjectors">"2"</constant>
        <constant name="engineType">"Even fire"</constant>
        <constant name="flexEnabled">"Off"</constant>
        <constant name="legacyMAP">"No"</constant>
        <constant name="baroCorr">"Off"</constant>
        <constant name="injLayout">"Paired"</constant>
        <constant name="perToothIgn">"Yes"</constant>
        <constant name="dfcoEnabled">"Off"</constant>
        <constant digits="0" name="aeColdTaperMax" units="C">60.0</constant>
        <constant digits="0" name="dutyLim" units="%">80.0</constant>
        <constant digits="0" name="flexFreqLow" units="Hz">50.0</constant>
        <constant digits="0" name="flexFreqHigh" units="Hz">150.0</constant>
        <constant digits="0" name="boostMaxDuty" units="%">80.0</constant>
        <constant digits="0" name="tpsMin" units="ADC">24.0</constant>
        <constant digits="0" name="tpsMax" units="ADC">209.0</constant>
        <constant digits="0" name="mapMin" units="kpa">10.0</constant>
        <constant digits="0" name="mapMax" units="kpa">260.0</constant>
        <constant digits="0" name="fpPrime" units="s">3.0</constant>
        <constant digits="1" name="stoich" units=":1">14.7</constant>
        <constant digits="0" name="oddfire2" units="deg">0.0</constant>
        <constant digits="0" name="oddfire3" units="deg">0.0</constant>
        <constant digits="0" name="oddfire4" units="deg">0.0</constant>
        <constant name="idleUpPin">"44"</constant>
        <constant name="idleUpPolarity">"Normal"</constant>
        <constant name="idleUpEnabled">"Off"</constant>
        <constant digits="0" name="idleUpAdder" units="% / Steps">15.0</constant>
        <constant digits="0" name="aeTaperMin" units="RPM">1000.0</constant>
        <constant digits="0" name="aeTaperMax" units="RPM">5000.0</constant>
        <constant digits="0" name="iacCLminDuty" units="%">0.0</constant>
        <constant digits="0" name="iacCLmaxDuty" units="%">100.0</constant>
        <constant digits="0" name="boostMinDuty" units="%">20.0</constant>
        <constant digits="0" name="baroMin" units="kpa">1.0</constant>
        <constant digits="0" name="baroMax" units="kpa">315.0</constant>
        <constant digits="0" name="EMAPMin" units="kpa">10.0</constant>
        <constant digits="0" name="EMAPMax" units="kpa">260.0</constant>
        <constant name="fanWhenOff">"Yes"</constant>
        <constant name="fanWhenCranking">"No"</constant>
        <constant name="useDwellMap">"No"</constant>
        <constant name="fanEnable">"On/Off"</constant>
        <constant name="rtc_mode">"Off"</constant>
        <constant name="incorporateAFR">"No"</constant>
        <constant cols="1" digits="0" name="asePct" rows="4" units="%">
         50.0 
         40.0 
         35.0 
         35.0 
      </constant>
        <constant cols="1" digits="0" name="aseCount" rows="4" units="s">
         10.0 
         5.0 
         5.0 
         3.0 
      </constant>
        <constant cols="1" digits="0" name="aseBins" rows="4" units="C">
         0.0 
         40.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="1" name="primePulse" rows="4" units="ms">
         1.0 
         1.0 
         1.0 
         1.0 
      </constant>
        <constant cols="1" digits="0" name="primeBins" rows="4" units="C">
         0.0 
         40.0 
         60.0 
         100.0 
      </constant>
        <constant name="CTPSPin">"Board Default"</constant>
        <constant name="CTPSPolarity">"Inverted"</constant>
        <constant name="CTPSEnabled">"On"</constant>
        <constant name="idleAdvEnabled">"Off"</constant>
        <constant name="idleAdvAlgorithm">"TPS"</constant>
        <constant name="idleAdvDelay">"0.0"</constant>
        <constant digits="0" name="idleAdvRPM" units="rpm">1000.0</constant>
        <constant digits="1" name="idleAdvTPS" units="%">8.0</constant>
        <constant cols="1" digits="0" name="injAngRPM" rows="4" units="RPM">
         500.0 
         2000.0 
         4500.0 
         6500.0 
      </constant>
        <constant digits="1" name="idleTaperTime" units="S">5.0</constant>
        <constant digits="1" name="dfcoDelay" units="S">1.0</constant>
        <constant digits="0" name="dfcoMinCLT" units="C">50.0</constant>
        <constant name="vssMode">"Off"</constant>
        <constant name="vssPin">"Board Default"</constant>
        <constant digits="0" name="vssPulsesPerKm" units="pulses">0.0</constant>
        <constant digits="0" name="vssSmoothing" units="%">50.0</constant>
        <constant digits="1" name="vssRatio1" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio2" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio3" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio4" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio5" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio6" units="km/h per 1000rpm">0.0</constant>
        <constant name="idleUpOutputEnabled">"Off"</constant>
        <constant name="idleUpOutputInv">"No"</constant>
        <constant name="idleUpOutputPin">"19"</constant>
        <constant digits="0" name="tachoSweepMaxRPM" units="RPM">7600.0</constant>
        <constant digits="1" name="primingDelay" units="S">0.5</constant>
        <constant digits="1" name="iacTPSlimit" units="%">126.0</constant>
        <constant digits="0" name="iacRPMlimitHysteresis" units="RPM">2550.0</constant>
        <constant digits="0" name="rtc_trim" units="ppm">-1.0</constant>
        <constant digits="0" name="idleAdvVss" units="km/h">255.0</constant>
        <constant digits="0" name="mapSwitchPoint" units="RPM">0.0</constant>
        <constant name="canBMWCluster">"Off"</constant>
        <constant name="canVAGCluster">"Off"</constant>
        <constant name="enable1Cluster">"On"</constant>
        <constant name="enable2Cluster">"On"</constant>
        <constant name="unusedClusterBits">"Off"</constant>
        <constant digits="0" name="unused2-95" units="RPM">25500.0</constant>
    </page>
    <page number="1" size="288">
        <constant cols="16" digits="0" name="veTable" rows="16" units="%">
         26.0 24.0 22.0 19.0 19.0 18.0 17.0 17.0 17.0 16.0 13.0 11.0 12.0 13.0 14.0 14.0 
         52.0 40.0 29.0 25.0 22.0 21.0 20.0 20.0 20.0 16.0 14.0 13.0 13.0 14.0 14.0 14.0 
         56.0 40.0 30.0 26.0 23.0 22.0 21.0 20.0 20.0 16.0 14.0 13.0 14.0 14.0 14.0 14.0 
         63.0 43.0 32.0 29.0 26.0 24.0 22.0 21.0 20.0 17.0 16.0 14.0 15.0 14.0 14.0 14.0 
         66.0 49.0 34.0 31.0 28.0 25.0 24.0 22.0 21.0 19.0 16.0 14.0 14.0 14.0 14.0 14.0 
         64.0 54.0 39.0 34.0 32.0 29.0 27.0 26.0 24.0 22.0 19.0 15.0 15.0 14.0 14.0 14.0 
         61.0 58.0 44.0 39.0 38.0 36.0 34.0 33.0 31.0 30.0 28.0 23.0 20.0 19.0 18.0 17.0 
         74.0 67.0 56.0 52.0 48.0 47.0 46.0 44.0 43.0 42.0 41.0 41.0 40.0 39.0 35.0 32.0 
         88.0 73.0 71.0 62.0 56.0 53.0 53.0 54.0 52.0 51.0 50.0 49.0 47.0 45.0 44.0 44.0 
         90.0 80.0 76.0 74.0 74.0 58.0 57.0 58.0 57.0 56.0 56.0 53.0 50.0 50.0 53.0 53.0 
         92.0 84.0 80.0 79.0 78.0 66.0 65.0 63.0 61.0 61.0 59.0 56.0 62.0 63.0 60.0 60.0 
         94.0 85.0 83.0 85.0 87.0 80.0 78.0 76.0 72.0 68.0 70.0 77.0 75.0 72.0 68.0 67.0 
         95.0 94.0 90.0 93.0 92.0 89.0 88.0 89.0 88.0 87.0 85.0 84.0 81.0 79.0 75.0 74.0 
         95.0 95.0 94.0 93.0 93.0 93.0 92.0 91.0 90.0 89.0 88.0 87.0 86.0 83.0 80.0 79.0 
         95.0 95.0 95.0 94.0 94.0 93.0 93.0 92.0 91.0 91.0 90.0 89.0 89.0 87.0 84.0 83.0 
         96.0 96.0 96.0 96.0 96.0 95.0 94.0 94.0 93.0 92.0 92.0 91.0 90.0 89.0 88.0 87.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins" rows="16" units="RPM">
         600.0 
         900.0 
         1200.0 
         1600.0 
         2000.0 
         2300.0 
         2700.0 
         3000.0 
         3400.0 
         3800.0 
         4200.0 
         4500.0 
         4900.0 
         5300.0 
         5700.0 
         6000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelLoadBins" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         4.0 
         5.0 
         10.0 
         20.0 
         30.0 
         40.0 
         50.0 
         60.0 
         70.0 
         80.0 
         90.0 
         100.0 
      </constant>
    </page>
    <page number="2" size="288">
        <constant cols="16" digits="0" name="advTable1" rows="16" units="deg">
         16.0 3.0 9.0 12.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         14.0 14.0 15.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         15.0 15.0 15.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 23.0 27.0 30.0 32.0 35.0 37.0 37.0 37.0 37.0 37.0 37.0 
         16.0 16.0 16.0 17.0 20.0 23.0 26.0 29.0 32.0 35.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 17.0 20.0 23.0 26.0 29.0 32.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 17.0 18.0 21.0 24.0 27.0 30.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 16.0 18.0 21.0 24.0 27.0 30.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 16.0 18.0 20.0 23.0 26.0 30.0 33.0 35.0 35.0 35.0 35.0 35.0 35.0 
         16.0 16.0 16.0 16.0 18.0 19.0 22.0 25.0 29.0 32.0 34.0 34.0 34.0 34.0 34.0 34.0 
         14.0 14.0 14.0 15.0 16.0 19.0 22.0 25.0 28.0 31.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins2" rows="16" units="RPM">
         600.0 
         900.0 
         1100.0 
         1300.0 
         1500.0 
         1800.0 
         2200.0 
         2600.0 
         2900.0 
         3300.0 
         3700.0 
         4000.0 
         4400.0 
         4800.0 
         5000.0 
         6000.0 
      </constant>
        <constant cols="1" digits="1" name="mapBins1" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         7.0 
         12.0 
         16.0 
         21.0 
         29.0 
         37.0 
         46.0 
         55.0 
         67.0 
         80.0 
         91.0 
         100.0 
      </constant>
    </page>
    <page number="3" size="128">
        <constant digits="0" name="TrigAng" units="Deg">-50.0</constant>
        <constant digits="0" name="FixAng" units="Deg">0.0</constant>
        <constant digits="0" name="CrankAng" units="Deg">10.0</constant>
        <constant digits="0" name="TrigAngMul">0.0</constant>
        <constant name="TrigEdge">"FALLING"</constant>
        <constant name="TrigSpeed">"Crank Speed"</constant>
        <constant name="IgInv">"Going Low"</constant>
        <constant name="TrigPattern">"Missing Tooth"</constant>
        <constant name="TrigEdgeSec">"FALLING"</constant>
        <constant name="fuelPumpPin">"Board Default"</constant>
        <constant name="useResync">"No"</constant>
        <constant digits="1" name="sparkDur" units="ms">1.0</constant>
        <constant name="trigPatternSec">"Single tooth cam"</constant>
        <constant name="PollLevelPol">"Low"</constant>
        <constant digits="0" name="bootloaderCaps" units="level">0.0</constant>
        <constant name="resetControl">"Serial Command"</constant>
        <constant name="resetControlPin">"Board Default"</constant>
        <constant digits="0" name="SkipCycles" units="cycles">1.0</constant>
        <constant name="boostType">"Open Loop"</constant>
        <constant name="useDwellLim">"On"</constant>
        <constant name="sparkMode">"Wasted Spark"</constant>
        <constant name="TrigFilter">"Weak"</constant>
        <constant name="ignCranklock">"Off"</constant>
        <constant digits="1" name="dwellcrank" units="ms">4.5</constant>
        <constant digits="1" name="dwellrun" units="ms">3.0</constant>
        <constant digits="0" name="numTeeth" units="teeth">36.0</constant>
        <constant digits="0" name="missingTeeth" units="teeth">1.0</constant>
        <constant digits="0" name="crankRPM" units="rpm">400.0</constant>
        <constant digits="1" name="tpsflood" units="%">80.0</constant>
        <constant digits="0" name="SoftRevLim" units="rpm">5000.0</constant>
        <constant digits="0" name="SoftLimRetard" units="deg">20.0</constant>
        <constant digits="1" name="SoftLimMax" units="s">2.0</constant>
        <constant digits="0" name="hardRevLim" units="rpm">5500.0</constant>
        <constant cols="1" digits="0" name="taeBins" rows="4" units="%/s">
         70.0 
         220.0 
         430.0 
         790.0 
      </constant>
        <constant cols="1" digits="0" name="taeRates" rows="4" units="%">
         15.0 
         59.0 
         74.0 
         85.0 
      </constant>
        <constant cols="1" digits="0" name="wueBins" rows="10" units="C">
         -40.0 
         -26.0 
         -8.0 
         9.0 
         26.0 
         38.0 
         49.0 
         60.0 
         69.0 
         80.0 
      </constant>
        <constant digits="0" name="dwellLim" units="ms">8.0</constant>
        <constant cols="1" digits="0" name="dwellRates" rows="6" units="%">
         110.0 
         105.0 
         100.0 
         100.0 
         91.0 
         85.0 
      </constant>
        <constant cols="1" digits="0" name="iatRetBins" rows="6" units="C">
         58.0 
         82.0 
         93.0 
         104.0 
         116.0 
         125.0 
      </constant>
        <constant cols="1" digits="0" name="iatRetRates" rows="6" units="deg">
         0.0 
         0.0 
         2.0 
         4.0 
         6.0 
         10.0 
      </constant>
        <constant digits="0" name="dfcoRPM" units="RPM">1500.0</constant>
        <constant digits="0" name="dfcoHyster" units="RPM">200.0</constant>
        <constant digits="1" name="dfcoTPSThresh" units="%">2.0</constant>
        <constant name="ignBypassEnable">"Off"</constant>
        <constant name="ignBypassPin">"3"</constant>
        <constant name="ignBypassHiLo">"LOW"</constant>
        <constant digits="0" name="ADCFILTER_TPS" units="%">50.0</constant>
        <constant digits="0" name="ADCFILTER_CLT" units="%">180.0</constant>
        <constant digits="0" name="ADCFILTER_IAT" units="%">180.0</constant>
        <constant digits="0" name="ADCFILTER_O2" units="%">100.0</constant>
        <constant digits="0" name="ADCFILTER_BAT" units="%">128.0</constant>
        <constant digits="0" name="ADCFILTER_MAP" units="%">20.0</constant>
        <constant digits="0" name="ADCFILTER_BARO" units="%">64.0</constant>
        <constant cols="1" digits="0" name="cltAdvBins" rows="6" units="C">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="cltAdvValues" rows="6" units="deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="maeBins" rows="4" units="kpa/s">
         80.0 
         220.0 
         500.0 
         860.0 
      </constant>
        <constant cols="1" digits="0" name="maeRates" rows="4" units="%">
         50.0 
         73.0 
         92.0 
         94.0 
      </constant>
        <constant digits="1" name="batVoltCorrect" units="v">0.0</constant>
        <constant cols="1" digits="0" name="baroFuelBins" rows="8" units="kPa">
         87.0 
         93.0 
         97.0 
         99.0 
         101.0 
         102.0 
         103.0 
         107.0 
      </constant>
        <constant cols="1" digits="0" name="baroFuelValues" rows="8" units="%">
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="idleAdvBins" rows="6" units="RPM">
         -200.0 
         -90.0 
         -10.0 
         70.0 
         160.0 
         240.0 
      </constant>
        <constant cols="1" digits="0" name="idleAdvValues" rows="6" units="deg">
         15.0 
         10.0 
         5.0 
         0.0 
         -5.0 
         -10.0 
      </constant>
        <constant digits="0" name="engineProtectMaxRPM" units="rpm">2000.0</constant>
        <constant digits="0" name="vvt2CL0DutyAng" units="deg">1540.0</constant>
        <constant name="vvt2PWMdir">"Advance"</constant>
        <constant name="inj4CylPairing">"1+3 &amp; 2+4"</constant>
        <constant name="unusedBits4_123">"0"</constant>
        <constant digits="0" name="ANGLEFILTER_VVT" units="%">0.0</constant>
        <constant digits="0" name="FILTER_FLEX" units="%">8.0</constant>
        <constant digits="0" name="vvtMinClt" units="C">-40.0</constant>
        <constant digits="0" name="vvtDelay" units="S">0.0</constant>
    </page>
    <page number="4" size="288">
        <constant cols="16" digits="3" name="afrTable" rows="16" units="Lambda">
         0.952381 0.952381 0.952381 1.0 1.0204082 1.0272109 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0204082 1.0068027 1.0 1.0 1.0 0.9931973 0.9863946 0.9863946 0.9795918 0.9795918 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 0.9931973 0.9863946 0.9795918 0.9727891 0.9659864 0.952381 0.952381 0.952381 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 0.9863946 0.9727891 0.9591837 0.9455782 0.9387755 0.9251701 0.9251701 0.9183673 
         0.9727891 0.9727891 0.9727891 1.0 1.0 1.0 1.0 0.9863946 0.9591837 0.9387755 0.9387755 0.9387755 0.9319728 0.9183673 0.9183673 0.9115646 
         0.9659864 0.9659864 0.9659864 1.0 1.0 1.0 1.0 0.9727891 0.9455782 0.9251701 0.9251701 0.9251701 0.9115646 0.8979592 0.8979592 0.8911565 
         0.9591837 0.9591837 0.9659864 0.9863946 0.9863946 0.9795918 0.9659864 0.9455782 0.9183673 0.8979592 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.877551 
         0.9591837 0.9591837 0.9659864 0.9727891 0.9591837 0.952381 0.9455782 0.9251701 0.9047619 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.877551 0.877551 
         0.9591837 0.9591837 0.9659864 0.9591837 0.9319728 0.9251701 0.9251701 0.9047619 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.8707483 0.8707483 0.8707483 
         0.952381 0.952381 0.952381 0.9319728 0.9115646 0.9115646 0.9047619 0.8911565 0.8843537 0.877551 0.877551 0.877551 0.8707483 0.8707483 0.8707483 0.8707483 
         0.9319728 0.9319728 0.9319728 0.877551 0.8707483 0.877551 0.877551 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 
         0.9115646 0.9115646 0.9115646 0.877551 0.8707483 0.8707483 0.8707483 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 
         0.8911565 0.8911565 0.8911565 0.8707483 0.8707483 0.8707483 0.8639456 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 
         0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8639456 0.8571429 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsAFR" rows="16" units="RPM">
         500.0 
         700.0 
         900.0 
         1400.0 
         2000.0 
         2800.0 
         3600.0 
         4500.0 
         5200.0 
         5500.0 
         5800.0 
         6200.0 
         6500.0 
         6800.0 
         6900.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsAFR" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         4.0 
         8.0 
         16.0 
         20.0 
         30.0 
         40.0 
         50.0 
         60.0 
         70.0 
         80.0 
         90.0 
         100.0 
      </constant>
    </page>
    <page number="5" size="128">
        <constant name="egoAlgorithm">"No correction"</constant>
        <constant name="egoType">"Wide Band"</constant>
        <constant name="boostEnabled">"Off"</constant>
        <constant name="vvtEnabled">"Off"</constant>
        <constant name="engineProtectType">"Both"</constant>
        <constant digits="0" name="egoKP" units="%">35.0</constant>
        <constant digits="0" name="egoKI" units="%">0.0</constant>
        <constant digits="0" name="egoKD" units="%">20.0</constant>
        <constant digits="0" name="egoTemp" units="C">70.0</constant>
        <constant digits="0" name="egoCount">16.0</constant>
        <constant name="vvtMode">"On/Off"</constant>
        <constant name="vvtLoadSource">"MAP"</constant>
        <constant name="vvtPWMdir">"Advance"</constant>
        <constant name="vvtCLUseHold">"No"</constant>
        <constant name="vvtCLAlterFuelTiming">"No"</constant>
        <constant name="boostCutEnabled">"Off"</constant>
        <constant digits="0" name="egoLimit">15.0</constant>
        <constant digits="1" name="ego_min" units="AFR">9.0</constant>
        <constant digits="1" name="ego_max" units="AFR">19.0</constant>
        <constant digits="0" name="ego_sdelay" units="sec">15.0</constant>
        <constant digits="0" name="egoRPM" units="rpm">1200.0</constant>
        <constant digits="1" name="egoTPSMax" units="%">12.0</constant>
        <constant name="vvt1Pin">"Board Default"</constant>
        <constant name="useExtBaro">"No"</constant>
        <constant name="boostMode">"Simple"</constant>
        <constant name="boostPin">"Board Default"</constant>
        <constant name="tachoMode">"Fixed Duration"</constant>
        <constant name="useEMAP">"No"</constant>
        <constant cols="1" digits="1" name="brvBins" rows="6" units="V">
         6.6 
         9.4 
         12.1 
         14.8 
         16.9 
         20.3 
      </constant>
        <constant cols="1" digits="0" name="injBatRates" rows="6" units="%">
         150.0 
         120.0 
         100.0 
         100.0 
         100.0 
         98.0 
      </constant>
        <constant cols="1" digits="0" name="airDenBins" rows="9" units="C">
         -40.0 
         -20.0 
         0.0 
         20.0 
         35.0 
         50.0 
         60.0 
         90.0 
         120.0 
      </constant>
        <constant cols="1" digits="0" name="airDenRates" rows="9" units="%">
         126.0 
         116.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
         81.0 
         74.0 
      </constant>
        <constant digits="0" name="boostFreq" units="Hz">30.0</constant>
        <constant digits="0" name="vvtFreq" units="Hz">300.0</constant>
        <constant digits="0" name="idleFreq" units="Hz">120.0</constant>
        <constant name="launchPin">"Board Default"</constant>
        <constant name="launchEnable">"No"</constant>
        <constant name="launchHiLo">"LOW"</constant>
        <constant digits="0" name="lnchSoftLim" units="rpm">3500.0</constant>
        <constant digits="0" name="lnchRetard" units="deg">15.0</constant>
        <constant digits="0" name="lnchHardLim" units="rpm">4000.0</constant>
        <constant digits="0" name="lnchFuelAdd" units="%">50.0</constant>
        <constant digits="2" name="idleKP" units="%">0.8125</constant>
        <constant digits="2" name="idleKI" units="%">0.0</constant>
        <constant digits="3" name="idleKD" units="%">0.49984</constant>
        <constant digits="0" name="boostLimit" units="kPa">200.0</constant>
        <constant digits="0" name="boostKP" units="%">50.0</constant>
        <constant digits="0" name="boostKI" units="%">0.0</constant>
        <constant digits="0" name="boostKD" units="%">10.0</constant>
        <constant name="lnchPullRes">"Pullup"</constant>
        <constant name="iacPWMrun">"No"</constant>
        <constant name="fuelTrimEnabled">"No"</constant>
        <constant name="flatSEnable">"No"</constant>
        <constant name="baroPin">"A0"</constant>
        <constant digits="0" name="flatSSoftWin" units="rpm">400.0</constant>
        <constant digits="0" name="flatSRetard" units="deg">5.0</constant>
        <constant digits="0" name="flatSArm" units="rpm">2000.0</constant>
        <constant cols="1" digits="0" name="iacCLValues" rows="10" units="RPM">
         1200.0 
         1150.0 
         1100.0 
         800.0 
         750.0 
         750.0 
         750.0 
         750.0 
         750.0 
         750.0 
      </constant>
        <constant cols="1" digits="0" name="iacOLStepVal" rows="10" units="Steps">
         369.0 
         327.0 
         291.0 
         246.0 
         213.0 
         168.0 
         123.0 
         87.0 
         45.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="iacOLPWMVal" rows="10" units="Duty %">
         43.0 
         39.0 
         33.0 
         29.0 
         24.0 
         20.0 
         17.0 
         17.0 
         16.0 
         9.0 
      </constant>
        <constant cols="1" digits="0" name="iacBins" rows="10" units="C">
         -38.0 
         -19.0 
         1.0 
         17.0 
         34.0 
         50.0 
         65.0 
         79.0 
         98.0 
         143.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankSteps" rows="4" units="Steps">
         123.0 
         579.0 
         390.0 
         300.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankDuty" rows="4" units="Duty %">
         27.0 
         50.0 
         60.0 
         65.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankBins" rows="4" units="C">
         -28.0 
         6.0 
         44.0 
         76.0 
      </constant>
        <constant name="iacAlgorithm">"None"</constant>
        <constant name="iacStepTime">"3"</constant>
        <constant name="iacChannels">"2"</constant>
        <constant name="iacPWMdir">"Normal"</constant>
        <constant digits="0" name="iacFastTemp" units="C">50.0</constant>
        <constant digits="0" name="iacStepHome" units="Steps">240.0</constant>
        <constant digits="0" name="iacStepHyster" units="Steps">4.0</constant>
        <constant name="fanInv">"No"</constant>
        <constant name="fanUnused">"Off"</constant>
        <constant name="fanPin">"Board Default"</constant>
        <constant digits="0" name="fanSP" units="C">89.0</constant>
        <constant digits="0" name="fanHyster" units="C">2.0</constant>
        <constant digits="0" name="fanFreq" units="Hz">6.0</constant>
        <constant cols="1" digits="0" name="fanPWMBins" rows="4" units="C">
         60.0 
         -20.0 
         -40.0 
         158.0 
      </constant>
    </page>
    <page number="6" size="240">
        <constant cols="8" digits="0" name="boostTable" rows="8" units="Duty Cycle %">
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsBoost" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="1" name="tpsBinsBoost" rows="8" units="TPS">
         0.0 
         20.0 
         40.0 
         80.0 
         100.0 
         120.0 
         32.0 
         72.0 
      </constant>
        <constant cols="8" digits="1" name="vvtTable" rows="8" units="%">
         94.0 0.0 0.0 54.0 8.0 8.0 0.0 0.0 
         70.0 16.0 12.0 0.0 12.0 12.0 0.0 2.0 
         48.0 44.0 40.0 36.0 36.0 36.0 38.0 40.0 
         64.0 60.0 58.0 56.0 54.0 54.0 54.0 58.0 
         78.0 78.0 76.0 76.0 74.0 74.0 72.0 72.0 
         92.0 94.0 94.0 92.0 92.0 90.0 90.0 86.0 
         112.0 112.0 112.0 110.0 110.0 110.0 110.0 112.0 
         8.0 8.0 10.0 10.0 10.0 10.0 10.0 10.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsVVT" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsVVT" rows="8" units="kPa">
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
      </constant>
        <constant cols="8" digits="0" name="stagingTable" rows="8" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsStaging" rows="8" units="RPM">
         500.0 
         1000.0 
         2000.0 
         3000.0 
         4000.0 
         5000.0 
         6000.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsStaging" rows="8" units="% TPS">
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
    </page>
    <page number="7" size="384">
        <constant cols="6" digits="0" name="fuelTrim1Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim1rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim1loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim2Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim2rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim2loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim3Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim3rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim3loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim4Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim4rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim4loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim5Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim5rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim5loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim6Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim6rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim6loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim7Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim7rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim7loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim8Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim8rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim8loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
    </page>
    <page number="8" size="192">
        <constant name="enable_secondarySerial">"Disable"</constant>
        <constant name="intcan_available">"Disable"</constant>
        <constant name="enable_intcan">"Disable"</constant>
        <constant name="caninput_sel0a">"Off"</constant>
        <constant name="caninput_sel0b">"Digital_local"</constant>
        <constant name="caninput_sel0extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel0extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel0extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel1a">"Off"</constant>
        <constant name="caninput_sel1b">"Digital_local"</constant>
        <constant name="caninput_sel1extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel1extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel1extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel2a">"Off"</constant>
        <constant name="caninput_sel2b">"Digital_local"</constant>
        <constant name="caninput_sel2extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel2extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel2extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel3a">"Off"</constant>
        <constant name="caninput_sel3b">"Digital_local"</constant>
        <constant name="caninput_sel3extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel3extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel3extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel4a">"Off"</constant>
        <constant name="caninput_sel4b">"Digital_local"</constant>
        <constant name="caninput_sel4extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel4extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel4extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel5a">"Off"</constant>
        <constant name="caninput_sel5b">"Digital_local"</constant>
        <constant name="caninput_sel5extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel5extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel5extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel6a">"Off"</constant>
        <constant name="caninput_sel6b">"Digital_local"</constant>
        <constant name="caninput_sel6extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel6extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel6extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel7a">"Off"</constant>
        <constant name="caninput_sel7b">"Digital_local"</constant>
        <constant name="caninput_sel7extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel7extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel7extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel8a">"Off"</constant>
        <constant name="caninput_sel8b">"Digital_local"</constant>
        <constant name="caninput_sel8extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel8extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel8extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel9a">"Off"</constant>
        <constant name="caninput_sel9b">"Digital_local"</constant>
        <constant name="caninput_sel9extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel9extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel9extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel10a">"Off"</constant>
        <constant name="caninput_sel10b">"Digital_local"</constant>
        <constant name="caninput_sel10extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel10extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel10extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel11a">"Off"</constant>
        <constant name="caninput_sel11b">"Digital_local"</constant>
        <constant name="caninput_sel11extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel11extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel11extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel12a">"Off"</constant>
        <constant name="caninput_sel12b">"Digital_local"</constant>
        <constant name="caninput_sel12extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel12extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel12extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel13a">"Off"</constant>
        <constant name="caninput_sel13b">"Digital_local"</constant>
        <constant name="caninput_sel13extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel13extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel13extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel14a">"Off"</constant>
        <constant name="caninput_sel14b">"Digital_local"</constant>
        <constant name="caninput_sel14extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel14extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel14extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel15a">"Off"</constant>
        <constant name="caninput_sel15b">"Digital_local"</constant>
        <constant name="caninput_sel15extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel15extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel15extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_source_can_address0">"0x100"</constant>
        <constant name="caninput_source_can_address1">"0x100"</constant>
        <constant name="caninput_source_can_address2">"0x100"</constant>
        <constant name="caninput_source_can_address3">"0x100"</constant>
        <constant name="caninput_source_can_address4">"0x100"</constant>
        <constant name="caninput_source_can_address5">"0x100"</constant>
        <constant name="caninput_source_can_address6">"0x100"</constant>
        <constant name="caninput_source_can_address7">"0x100"</constant>
        <constant name="caninput_source_can_address8">"0x706"</constant>
        <constant name="caninput_source_can_address9">"0x100"</constant>
        <constant name="caninput_source_can_address10">"0x100"</constant>
        <constant name="caninput_source_can_address11">"0x100"</constant>
        <constant name="caninput_source_can_address12">"0x100"</constant>
        <constant name="caninput_source_can_address13">"0x100"</constant>
        <constant name="caninput_source_can_address14">"0x100"</constant>
        <constant name="caninput_source_can_address15">"0x6FD"</constant>
        <constant name="caninput_source_start_byte0">"7"</constant>
        <constant name="caninput_source_start_byte1">"7"</constant>
        <constant name="caninput_source_start_byte2">"7"</constant>
        <constant name="caninput_source_start_byte3">"7"</constant>
        <constant name="caninput_source_start_byte4">"7"</constant>
        <constant name="caninput_source_start_byte5">"7"</constant>
        <constant name="caninput_source_start_byte6">"7"</constant>
        <constant name="caninput_source_start_byte7">"7"</constant>
        <constant name="caninput_source_start_byte8">"7"</constant>
        <constant name="caninput_source_start_byte9">"7"</constant>
        <constant name="caninput_source_start_byte10">"7"</constant>
        <constant name="caninput_source_start_byte11">"7"</constant>
        <constant name="caninput_source_start_byte12">"7"</constant>
        <constant name="caninput_source_start_byte13">"7"</constant>
        <constant name="caninput_source_start_byte14">"7"</constant>
        <constant name="caninput_source_start_byte15">"7"</constant>
        <constant name="caninput_source_num_bytes0">"2"</constant>
        <constant name="caninput_source_num_bytes1">"2"</constant>
        <constant name="caninput_source_num_bytes2">"2"</constant>
        <constant name="caninput_source_num_bytes3">"2"</constant>
        <constant name="caninput_source_num_bytes4">"2"</constant>
        <constant name="caninput_source_num_bytes5">"2"</constant>
        <constant name="caninput_source_num_bytes6">"2"</constant>
        <constant name="caninput_source_num_bytes7">"2"</constant>
        <constant name="caninput_source_num_bytes8">"2"</constant>
        <constant name="caninput_source_num_bytes9">"2"</constant>
        <constant name="caninput_source_num_bytes10">"2"</constant>
        <constant name="caninput_source_num_bytes11">"2"</constant>
        <constant name="caninput_source_num_bytes12">"2"</constant>
        <constant name="caninput_source_num_bytes13">"2"</constant>
        <constant name="caninput_source_num_bytes14">"2"</constant>
        <constant name="caninput_source_num_bytes15">"2"</constant>
        <constant digits="0" name="unused10_67">255.0</constant>
        <constant digits="0" name="unused10_68">255.0</constant>
        <constant name="enable_intcandata_out">"On"</constant>
        <constant name="canoutput_sel0">"On"</constant>
        <constant name="canoutput_sel1">"On"</constant>
        <constant name="canoutput_sel2">"On"</constant>
        <constant name="canoutput_sel3">"On"</constant>
        <constant name="canoutput_sel4">"On"</constant>
        <constant name="canoutput_sel5">"On"</constant>
        <constant name="canoutput_sel6">"On"</constant>
        <constant name="canoutput_sel7">"On"</constant>
        <constant cols="1" digits="0" name="canoutput_param_group" rows="8">
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
      </constant>
        <constant name="canoutput_param_start_byte0">"7"</constant>
        <constant name="canoutput_param_start_byte1">"0"</constant>
        <constant name="canoutput_param_start_byte2">"0"</constant>
        <constant name="canoutput_param_start_byte3">"0"</constant>
        <constant name="canoutput_param_start_byte4">"0"</constant>
        <constant name="canoutput_param_start_byte5">"0"</constant>
        <constant name="canoutput_param_start_byte6">"0"</constant>
        <constant name="canoutput_param_start_byte7">"0"</constant>
        <constant name="canoutput_param_num_bytes0">"1"</constant>
        <constant name="canoutput_param_num_bytes1">"1"</constant>
        <constant name="canoutput_param_num_bytes2">"1"</constant>
        <constant name="canoutput_param_num_bytes3">"1"</constant>
        <constant name="canoutput_param_num_bytes4">"1"</constant>
        <constant name="canoutput_param_num_bytes5">"1"</constant>
        <constant name="canoutput_param_num_bytes6">"1"</constant>
        <constant name="canoutput_param_num_bytes7">"1"</constant>
        <constant digits="0" name="unused10_110">255.0</constant>
        <constant digits="0" name="unused10_111">255.0</constant>
        <constant digits="0" name="unused10_112">255.0</constant>
        <constant digits="0" name="unused10_113">255.0</constant>
        <constant name="speeduino_tsCanId">"CAN ID 0"</constant>
        <constant name="true_address">"0x101"</constant>
        <constant name="realtime_base_address">"0x201"</constant>
        <constant name="obd_address">"0x2FF"</constant>
        <constant name="Auxin0pina">"A0"</constant>
        <constant name="Auxin1pina">"A0"</constant>
        <constant name="Auxin2pina">"A0"</constant>
        <constant name="Auxin3pina">"A0"</constant>
        <constant name="Auxin4pina">"A0"</constant>
        <constant name="Auxin5pina">"A0"</constant>
        <constant name="Auxin6pina">"A4"</constant>
        <constant name="Auxin7pina">"A0"</constant>
        <constant name="Auxin8pina">"A1"</constant>
        <constant name="Auxin9pina">"A6"</constant>
        <constant name="Auxin10pina">"A10"</constant>
        <constant name="Auxin11pina">"A10"</constant>
        <constant name="Auxin12pina">"A10"</constant>
        <constant name="Auxin13pina">"A0"</constant>
        <constant name="Auxin14pina">"A5"</constant>
        <constant name="Auxin15pina">"A8"</constant>
        <constant name="Auxin0pinb">"30"</constant>
        <constant name="Auxin1pinb">"8"</constant>
        <constant name="Auxin2pinb">"1"</constant>
        <constant name="Auxin3pinb">"8"</constant>
        <constant name="Auxin4pinb">"11"</constant>
        <constant name="Auxin5pinb">"8"</constant>
        <constant name="Auxin6pinb">"12"</constant>
        <constant name="Auxin7pinb">"8"</constant>
        <constant name="Auxin8pinb">"1"</constant>
        <constant name="Auxin9pinb">"8"</constant>
        <constant name="Auxin10pinb">"26"</constant>
        <constant name="Auxin11pinb">"8"</constant>
        <constant name="Auxin12pinb">"46"</constant>
        <constant name="Auxin13pinb">"8"</constant>
        <constant name="Auxin14pinb">"7"</constant>
        <constant name="Auxin15pinb">"8"</constant>
        <constant name="iacStepperInv">"No"</constant>
        <constant name="iacCoolTime">"1"</constant>
        <constant name="boostByGearEnabled">"Constant limit"</constant>
        <constant name="blankfield">""</constant>
        <constant name="unused10_153">""</constant>
        <constant digits="0" name="iacMaxSteps" units="Steps">21.0</constant>
        <constant digits="1" name="idleAdvStartDelay" units="S">2.0</constant>
        <constant digits="0" name="boostByGear1" units="Limit">130.0</constant>
        <constant digits="0" name="boostByGear2" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear3" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear4" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear5" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear6" units="Limit">200.0</constant>
        <constant cols="1" digits="1" name="PWMFanDuty" rows="4" units="%">
         64.5 
         64.5 
         64.5 
         64.5 
      </constant>
        <constant name="hardRevMode">"Fixed"</constant>
        <constant cols="1" digits="0" name="coolantProtRPM" rows="6" units="RPM">
         12900.0 
         12900.0 
         12900.0 
         12900.0 
         12900.0 
         12900.0 
      </constant>
        <constant cols="1" digits="0" name="coolantProtTemp" rows="6" units="C">
         89.0 
         89.0 
         89.0 
         89.0 
         89.0 
         89.0 
      </constant>
        <constant cols="1" digits="0" name="unused179_184" rows="6">
         129.0 
         129.0 
         129.0 
         129.0 
         129.0 
         129.0 
      </constant>
        <constant name="afrProtectEnabled">"Off"</constant>
        <constant digits="0" name="afrProtectMAP" units="kPa">180.0</constant>
        <constant digits="0" name="afrProtectRPM" units="RPM">4000.0</constant>
        <constant digits="1" name="afrProtectTPS" units="%">80.0</constant>
        <constant digits="2" name="afrProtectDeviation" units="Lambda">0.0952381</constant>
        <constant digits="1" name="afrProtectCutTime" units="seconds">1.4</constant>
        <constant digits="1" name="afrProtectReactivationTPS" units="%">15.0</constant>
    </page>
    <page number="9" size="192">
        <constant cols="1" digits="0" name="crankingEnrichBins" rows="4" units="C">
         -40.0 
         0.0 
         30.0 
         70.0 
      </constant>
        <constant cols="1" digits="0" name="crankingEnrichValues" rows="4" units="%">
         600.0 
         300.0 
         300.0 
         300.0 
      </constant>
        <constant name="rotaryType">"FC"</constant>
        <constant name="stagingEnabled">"On"</constant>
        <constant name="stagingMode">"Automatic"</constant>
        <constant name="EMAPPin">"A0"</constant>
        <constant cols="1" digits="0" name="rotarySplitValues" rows="8" units="degrees">
         0.0 
         0.0 
         0.0 
         10.0 
         10.0 
         10.0 
         11.0 
         12.0 
      </constant>
        <constant cols="1" digits="1" name="rotarySplitBins" rows="8" units="% TPS">
         0.0 
         30.0 
         50.0 
         70.0 
         90.0 
         110.0 
         12.0 
         72.0 
      </constant>
        <constant digits="0" name="boostSens">2047.0</constant>
        <constant digits="0" name="boostIntv" units="ms">20.0</constant>
        <constant digits="0" name="stagedInjSizePri" units="cc/min">160.0</constant>
        <constant digits="0" name="stagedInjSizeSec" units="cc/min">160.0</constant>
        <constant digits="1" name="lnchCtrlTPS" units="%TPS">126.0</constant>
        <constant cols="1" digits="0" name="flexBoostBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexBoostAdj" rows="6" units="kPa">
         0.0 
         10.0 
         20.0 
         30.0 
         40.0 
         50.0 
      </constant>
        <constant cols="1" digits="0" name="flexFuelBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexFuelAdj" rows="6" units="%">
         100.0 
         139.0 
         156.0 
         160.0 
         163.0 
         163.0 
      </constant>
        <constant cols="1" digits="0" name="flexAdvBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexAdvAdj" rows="6" units="Deg">
         0.0 
         2.0 
         5.0 
         8.0 
         9.0 
         10.0 
      </constant>
        <constant name="n2o_enable">"Off"</constant>
        <constant name="n2o_arming_pin">"34"</constant>
        <constant digits="0" name="n2o_minCLT" units="C">20.0</constant>
        <constant digits="0" name="n2o_maxMAP" units="kPa">250.0</constant>
        <constant digits="1" name="n2o_minTPS" units="%TPS">60.0</constant>
        <constant digits="1" name="n2o_maxAFR" units="AFR">18.0</constant>
        <constant name="n2o_stage1_pin">"30"</constant>
        <constant name="n2o_pin_polarity">"LOW"</constant>
        <constant name="n2o_unused">"No"</constant>
        <constant digits="0" name="n2o_stage1_minRPM" units="RPM">3000.0</constant>
        <constant digits="0" name="n2o_stage1_maxRPM" units="RPM">6000.0</constant>
        <constant digits="1" name="n2o_stage1_adderMin" units="ms">6.0</constant>
        <constant digits="1" name="n2o_stage1_adderMax" units="ms">3.0</constant>
        <constant digits="0" name="n2o_stage1_retard" units="Deg">5.0</constant>
        <constant name="n2o_stage2_pin">"31"</constant>
        <constant name="n2o_stage2_unused">"No"</constant>
        <constant digits="0" name="n2o_stage2_minRPM" units="RPM">6000.0</constant>
        <constant digits="0" name="n2o_stage2_maxRPM" units="RPM">7000.0</constant>
        <constant digits="1" name="n2o_stage2_adderMin" units="ms">3.0</constant>
        <constant digits="1" name="n2o_stage2_adderMax" units="ms">1.5</constant>
        <constant digits="0" name="n2o_stage2_retard" units="Deg">5.0</constant>
        <constant name="knock_mode">"Analog"</constant>
        <constant name="knock_pin">"3"</constant>
        <constant name="knock_trigger">"LOW"</constant>
        <constant name="knock_pullup">"Off"</constant>
        <constant name="knock_limiterDisable">"No"</constant>
        <constant name="knock_unused">"3"</constant>
        <constant name="knock_count">"3"</constant>
        <constant digits="1" name="knock_threshold" units="Volts">7.5</constant>
        <constant digits="0" name="knock_maxMAP" units="kPa">100.0</constant>
        <constant digits="0" name="knock_maxRPM" units="RPM">1000.0</constant>
        <constant cols="1" digits="0" name="knock_window_rpms" rows="6" units="RPM">
         2000.0 
         3000.0 
         4000.0 
         5000.0 
         6000.0 
         5000.0 
      </constant>
        <constant cols="1" digits="0" name="knock_window_angle" rows="6" units="deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         -20.0 
      </constant>
        <constant cols="1" digits="0" name="knock_window_dur" rows="6" units="deg">
         30.0 
         30.0 
         30.0 
         30.0 
         30.0 
         15.0 
      </constant>
        <constant digits="0" name="knock_maxRetard" units="Deg">3.0</constant>
        <constant digits="0" name="knock_firstStep" units="Deg">1.0</constant>
        <constant digits="0" name="knock_stepSize" units="Deg">2.0</constant>
        <constant digits="1" name="knock_stepTime" units="Sec">2.0</constant>
        <constant digits="1" name="knock_duration" units="Sec">0.2</constant>
        <constant digits="1" name="knock_recoveryStepTime" units="Sec">0.1</constant>
        <constant digits="0" name="knock_recoveryStep" units="Deg">0.0</constant>
        <constant name="fuel2Algorithm">"MAP"</constant>
        <constant name="fuel2Mode">"Off"</constant>
        <constant name="fuel2SwitchVariable">"MAP"</constant>
        <constant digits="0" name="fuel2SwitchValue" units="kPa">120.0</constant>
        <constant name="fuel2InputPin">"25"</constant>
        <constant name="fuel2InputPolarity">"LOW"</constant>
        <constant name="fuel2InputPullup">"Yes"</constant>
        <constant digits="1" name="vvtCLholdDuty" units="%">82.0</constant>
        <constant digits="2" name="vvtCLKP" units="%">0.0</constant>
        <constant digits="2" name="vvtCLKI" units="%">0.0</constant>
        <constant digits="3" name="vvtCLKD" units="%">0.99968</constant>
        <constant digits="0" name="vvtCL0DutyAng" units="deg">0.0</constant>
        <constant digits="0" name="vvtCLMinAng" units="deg">112.0</constant>
        <constant digits="0" name="vvtCLMaxAng" units="deg">0.0</constant>
        <constant digits="1" name="crankingEnrichTaper" units="s">0.1</constant>
        <constant name="fuelPressureEnable">"Off"</constant>
        <constant name="oilPressureEnable">"Off"</constant>
        <constant name="oilPressureProtEnbl">"Off"</constant>
        <constant name="oilPressurePin">"A0"</constant>
        <constant name="fuelPressurePin">"A0"</constant>
        <constant digits="0" name="fuelPressureMin" units="psi">9.0</constant>
        <constant digits="0" name="fuelPressureMax" units="psi">47.0</constant>
        <constant digits="0" name="oilPressureMin" units="psi">116.0</constant>
        <constant digits="0" name="oilPressureMax" units="psi">33.0</constant>
        <constant cols="1" digits="0" name="oilPressureProtMins" rows="4" units="psi">
         0.0 
         30.0 
         45.0 
         45.0 
      </constant>
        <constant cols="1" digits="0" name="oilPressureProtRPM" rows="4" units="RPM">
         100.0 
         1500.0 
         4000.0 
         8000.0 
      </constant>
        <constant name="wmiEnabled">"Off"</constant>
        <constant name="wmiMode">"Simple"</constant>
        <constant name="wmiAdvEnabled">"Off"</constant>
        <constant digits="1" name="wmiTPS" units="%TPS">0.0</constant>
        <constant digits="0" name="wmiRPM" units="RPM">5900.0</constant>
        <constant digits="0" name="wmiMAP" units="kPa">510.0</constant>
        <constant digits="0" name="wmiMAP2" units="kPa">510.0</constant>
        <constant digits="0" name="wmiIAT" units="C">215.0</constant>
        <constant digits="0" name="wmiOffset" units="ms">0.0</constant>
        <constant name="wmiIndicatorEnabled">"Off"</constant>
        <constant name="wmiIndicatorPin">"Board Default"</constant>
        <constant name="wmiIndicatorPolarity">"Inverted"</constant>
        <constant name="wmiEmptyEnabled">"Off"</constant>
        <constant name="wmiEmptyPin">"Board Default"</constant>
        <constant name="wmiEmptyPolarity">"Inverted"</constant>
        <constant name="wmiEnabledPin">"Board Default"</constant>
        <constant cols="1" digits="0" name="wmiAdvBins" rows="6" units="kPa">
         0.0 
         100.0 
         200.0 
         300.0 
         400.0 
         500.0 
      </constant>
        <constant cols="1" digits="0" name="wmiAdvAdj" rows="6" units="Deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant digits="1" name="vvtCLminDuty" units="%">126.0</constant>
        <constant digits="1" name="vvtCLmaxDuty" units="%">126.0</constant>
        <constant name="vvt2Pin">"Board Default"</constant>
        <constant name="vvt2Enabled">"Off"</constant>
        <constant name="TrigEdgeThrd">"RISING"</constant>
        <constant cols="1" digits="0" name="fuelTempBins" rows="6" units="C">
         215.0 
         215.0 
         215.0 
         215.0 
         215.0 
         215.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTempValues" rows="6" units="%">
         255.0 
         64.0 
         100.0 
         0.0 
         3.0 
         255.0 
      </constant>
        <constant name="spark2Algorithm">"MAP"</constant>
        <constant name="spark2Mode">"Off"</constant>
        <constant name="spark2SwitchVariable">"MAP"</constant>
        <constant digits="0" name="spark2SwitchValue" units="kPa">100.0</constant>
        <constant name="spark2InputPin">"3"</constant>
        <constant name="spark2InputPolarity">"LOW"</constant>
        <constant name="spark2InputPullup">"No"</constant>
        <constant cols="1" digits="0" name="unused11_190_191" rows="2" units="RPM">
         1500.0 
         500.0 
      </constant>
    </page>
    <page number="10" size="288">
        <constant cols="16" digits="0" name="veTable2" rows="16" units="%">
         39.0 39.0 39.0 39.0 39.0 38.0 37.0 36.0 35.0 34.0 33.0 33.0 33.0 33.0 33.0 33.0 
         40.0 40.0 41.0 42.0 42.0 41.0 40.0 39.0 39.0 39.0 39.0 39.0 40.0 40.0 40.0 40.0 
         40.0 42.0 43.0 46.0 46.0 45.0 44.0 43.0 42.0 42.0 43.0 43.0 43.0 44.0 44.0 44.0 
         42.0 45.0 47.0 51.0 51.0 49.0 48.0 47.0 46.0 46.0 46.0 47.0 47.0 47.0 48.0 48.0 
         44.0 49.0 52.0 56.0 55.0 54.0 52.0 51.0 50.0 50.0 50.0 50.0 51.0 51.0 51.0 52.0 
         48.0 54.0 58.0 61.0 59.0 58.0 56.0 55.0 54.0 53.0 54.0 54.0 54.0 55.0 55.0 55.0 
         54.0 61.0 64.0 66.0 64.0 62.0 61.0 59.0 58.0 57.0 57.0 58.0 58.0 59.0 59.0 59.0 
         60.0 67.0 70.0 70.0 68.0 67.0 65.0 63.0 62.0 61.0 61.0 61.0 62.0 63.0 63.0 63.0 
         67.0 74.0 76.0 75.0 73.0 71.0 69.0 68.0 66.0 64.0 65.0 65.0 66.0 66.0 67.0 67.0 
         74.0 80.0 81.0 79.0 77.0 75.0 73.0 72.0 70.0 68.0 68.0 69.0 69.0 70.0 70.0 71.0 
         81.0 85.0 86.0 84.0 82.0 80.0 78.0 76.0 74.0 72.0 72.0 72.0 73.0 74.0 74.0 74.0 
         87.0 91.0 91.0 88.0 86.0 84.0 82.0 80.0 78.0 76.0 76.0 76.0 77.0 78.0 78.0 78.0 
         93.0 93.0 93.0 93.0 93.0 90.0 88.0 86.0 84.0 83.0 83.0 83.0 84.0 85.0 85.0 86.0 
         93.0 93.0 93.0 93.0 93.0 92.0 90.0 88.0 86.0 86.0 86.0 87.0 88.0 89.0 89.0 90.0 
         93.0 93.0 93.0 93.0 93.0 93.0 93.0 90.0 90.0 90.0 90.0 91.0 92.0 93.0 93.0 93.0 
         93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 95.0 
      </constant>
        <constant cols="1" digits="0" name="fuelRPM2Bins" rows="16" units="RPM">
         500.0 
         700.0 
         900.0 
         1400.0 
         2000.0 
         2800.0 
         3600.0 
         4500.0 
         5200.0 
         5500.0 
         5800.0 
         6200.0 
         6500.0 
         6800.0 
         6900.0 
         7000.0 
      </constant>
        <constant cols="1" digits="0" name="fuelLoad2Bins" rows="16" units="kPa">
         16.0 
         26.0 
         30.0 
         36.0 
         40.0 
         46.0 
         50.0 
         56.0 
         60.0 
         66.0 
         70.0 
         76.0 
         86.0 
         90.0 
         96.0 
         100.0 
      </constant>
    </page>
    <page number="11" size="192">
        <constant cols="8" digits="0" name="wmiTable" rows="8" units="%">
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsWMI" rows="8" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="0" name="mapBinsWMI" rows="8" units="kPa">
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
      </constant>
        <constant cols="8" digits="1" name="vvt2Table" rows="8" units="%">
         0.0 0.0 0.0 2.0 4.0 4.0 0.0 0.0 
         8.0 8.0 6.0 0.0 6.0 6.0 0.0 1.0 
         24.0 22.0 20.0 18.0 18.0 18.0 19.0 20.0 
         32.0 30.0 29.0 28.0 27.0 27.0 27.0 29.0 
         39.0 39.0 38.0 38.0 37.0 37.0 36.0 36.0 
         46.0 47.0 47.0 46.0 46.0 45.0 45.0 43.0 
         56.0 56.0 56.0 55.0 55.0 55.0 55.0 56.0 
         68.0 68.0 69.0 69.0 69.0 69.0 69.0 69.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsVVT2" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsVVT2" rows="8" units="kPa">
         0.0 
         20.0 
         30.0 
         40.0 
         56.0 
         70.0 
         86.0 
         100.0 
      </constant>
        <constant cols="4" digits="1" name="dwellTable" rows="4" units="ms">
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsDwell" rows="4" units="RPM">
         1000.0 
         3000.0 
         5000.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsDwell" rows="4" units="% TPS">
         5.0 
         12.5 
         17.5 
         25.0 
      </constant>
        <constant cols="1" digits="0" name="UNALLOCATED_TOP_11" rows="8" units="RAW">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
    </page>
    <page number="12" size="128">
        <constant name="outputInverted0">"Active low"</constant>
        <constant name="outputInverted1">"Active low"</constant>
        <constant name="outputInverted2">"Active low"</constant>
        <constant name="outputInverted3">"Active low"</constant>
        <constant name="outputInverted4">"Active low"</constant>
        <constant name="outputInverted5">"Active low"</constant>
        <constant name="outputInverted6">"Active low"</constant>
        <constant name="outputInverted7">"Active low"</constant>
        <constant name="kindOfLimiting0">"Minimum"</constant>
        <constant name="kindOfLimiting1">"Minimum"</constant>
        <constant name="kindOfLimiting2">"Minimum"</constant>
        <constant name="kindOfLimiting3">"Minimum"</constant>
        <constant name="kindOfLimiting4">"Minimum"</constant>
        <constant name="kindOfLimiting5">"Minimum"</constant>
        <constant name="kindOfLimiting6">"Minimum"</constant>
        <constant name="kindOfLimiting7">"Minimum"</constant>
        <constant cols="1" digits="0" name="outputPin" rows="8">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant name="outputPin0">"Disabled"</constant>
        <constant name="outputPin1">"Disabled"</constant>
        <constant name="outputPin2">"Disabled"</constant>
        <constant name="outputPin3">"Disabled"</constant>
        <constant name="outputPin4">"Disabled"</constant>
        <constant name="outputPin5">"Disabled"</constant>
        <constant name="outputPin6">"Disabled"</constant>
        <constant name="outputPin7">"Disabled"</constant>
        <constant cols="1" digits="1" name="outputDelay" rows="8" units="S">
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
      </constant>
        <constant cols="1" digits="0" name="firstDataIn" rows="8">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="0" name="secondDataIn" rows="8">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="1" name="outputTimeLimit" rows="8" units="S">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="unused13_35_49" rows="8" units="%">
         0.0 
         0.0 
         0.0 
         0.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="0" name="firstTarget" rows="8">
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
      </constant>
        <constant cols="1" digits="0" name="secondTarget" rows="8">
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
      </constant>
        <constant name="firstCompType0">"== (equal)"</constant>
        <constant name="secondCompType0">"== (equal)"</constant>
        <constant name="bitwise0">"XOR"</constant>
        <constant name="firstCompType1">"== (equal)"</constant>
        <constant name="secondCompType1">"== (equal)"</constant>
        <constant name="bitwise1">"XOR"</constant>
        <constant name="firstCompType2">"== (equal)"</constant>
        <constant name="secondCompType2">"== (equal)"</constant>
        <constant name="bitwise2">"XOR"</constant>
        <constant name="firstCompType3">"== (equal)"</constant>
        <constant name="secondCompType3">"== (equal)"</constant>
        <constant name="bitwise3">"XOR"</constant>
        <constant name="firstCompType4">"== (equal)"</constant>
        <constant name="secondCompType4">"== (equal)"</constant>
        <constant name="bitwise4">"XOR"</constant>
        <constant name="firstCompType5">"== (equal)"</constant>
        <constant name="secondCompType5">"== (equal)"</constant>
        <constant name="bitwise5">"XOR"</constant>
        <constant name="firstCompType6">"== (equal)"</constant>
        <constant name="secondCompType6">"== (equal)"</constant>
        <constant name="bitwise6">"XOR"</constant>
        <constant name="firstCompType7">"== (equal)"</constant>
        <constant name="secondCompType7">"== (equal)"</constant>
        <constant name="bitwise7">"XOR"</constant>
        <constant cols="1" digits="0" name="candID" rows="8">
         15711.0 
         15677.0 
         15677.0 
         52951.0 
         49864.0 
         47549.0 
         45493.0 
         43950.0 
      </constant>
        <constant cols="1" digits="0" name="unused12_106_115" rows="10" units="%">
         168.0 
         166.0 
         163.0 
         161.0 
         159.0 
         157.0 
         156.0 
         154.0 
         152.0 
         151.0 
      </constant>
        <constant name="onboard_log_csv_separator">","</constant>
        <constant name="onboard_log_file_style">"CSV"</constant>
        <constant name="onboard_log_file_rate">"4Hz"</constant>
        <constant name="onboard_log_filenaming">"Sequential"</constant>
        <constant name="onboard_log_storage">"sd-card"</constant>
        <constant name="onboard_log_trigger_boot">"On boot"</constant>
        <constant name="onboard_log_trigger_RPM">"Disabled"</constant>
        <constant name="onboard_log_trigger_prot">"Disabled"</constant>
        <constant name="onboard_log_trigger_Vbat">"Disabled"</constant>
        <constant name="onboard_log_trigger_Epin">"Disabled"</constant>
        <constant digits="0" name="onboard_log_tr1_duration" units="s">37266.0</constant>
        <constant digits="0" name="onboard_log_tr2_thr_on" units="RPM">14400.0</constant>
        <constant digits="0" name="onboard_log_tr2_thr_off" units="RPM">14300.0</constant>
        <constant name="onboard_log_tr3_thr_RPM">"Enabled"</constant>
        <constant name="onboard_log_tr3_thr_MAP">"Disabled"</constant>
        <constant name="onboard_log_tr3_thr_Oil">"Enabled"</constant>
        <constant name="onboard_log_tr3_thr_AFR">"Enabled"</constant>
        <constant digits="2" name="onboard_log_tr4_thr_on" units="V">14.0</constant>
        <constant digits="2" name="onboard_log_tr4_thr_off" units="V">14.0</constant>
        <constant name="onboard_log_tr5_Epin_pin">"10"</constant>
        <constant name="unused13_125_2">"tab"</constant>
        <constant cols="1" digits="0" name="unused12_125_127" rows="2" units="%">
         137.0 
         136.0 
      </constant>
    </page>
    <page number="13" size="288">
        <constant cols="16" digits="0" name="advTable2" rows="16" units="deg">
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 20.0 21.0 20.0 21.0 24.0 25.0 27.0 28.0 28.0 30.0 31.0 31.0 31.0 32.0 33.0 
         17.0 22.0 22.0 20.0 21.0 24.0 25.0 26.0 28.0 28.0 30.0 31.0 31.0 31.0 32.0 33.0 
         17.0 20.0 20.0 20.0 21.0 24.0 25.0 26.0 27.0 28.0 29.0 30.0 30.0 30.0 31.0 32.0 
         17.0 20.0 20.0 20.0 21.0 23.0 23.0 24.0 25.0 26.0 27.0 28.0 29.0 29.0 30.0 31.0 
         17.0 20.0 20.0 20.0 21.0 22.0 22.0 23.0 24.0 25.0 26.0 27.0 28.0 28.0 29.0 30.0 
         18.0 18.0 18.0 18.0 21.0 21.0 21.0 21.0 21.0 21.0 21.0 20.0 19.0 20.0 20.0 20.0 
         18.0 18.0 18.0 18.0 20.0 20.0 20.0 20.0 19.0 19.0 19.0 18.0 18.0 18.0 18.0 18.0 
         18.0 18.0 18.0 18.0 18.0 18.0 18.0 18.0 17.0 17.0 17.0 16.0 16.0 16.0 16.0 16.0 
         18.0 18.0 18.0 18.0 17.0 17.0 17.0 17.0 16.0 16.0 16.0 15.0 15.0 15.0 15.0 15.0 
         18.0 18.0 18.0 18.0 16.0 16.0 16.0 16.0 15.0 15.0 15.0 14.0 14.0 14.0 14.0 14.0 
         18.0 18.0 18.0 16.0 13.0 13.0 13.0 13.0 12.0 12.0 12.0 11.0 11.0 11.0 11.0 11.0 
         16.0 16.0 16.0 14.0 11.0 11.0 11.0 11.0 11.0 11.0 11.0 9.0 9.0 9.0 9.0 9.0 
         15.0 15.0 15.0 13.0 10.0 10.0 10.0 10.0 10.0 10.0 10.0 8.0 8.0 8.0 8.0 8.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins3" rows="16" units="RPM">
         500.0 
         700.0 
         1200.0 
         1700.0 
         2200.0 
         2700.0 
         3200.0 
         3700.0 
         4200.0 
         4700.0 
         5200.0 
         5700.0 
         6200.0 
         6700.0 
         7200.0 
         7700.0 
      </constant>
        <constant cols="1" digits="0" name="mapBins2" rows="16" units="kPa">
         110.0 
         116.0 
         120.0 
         126.0 
         130.0 
         136.0 
         140.0 
         146.0 
         150.0 
         156.0 
         166.0 
         174.0 
         180.0 
         188.0 
         196.0 
         200.0 
      </constant>
    </page>
    <page number="14" size="256">
        <constant cols="8" digits="0" name="boostTableDutyLookup" rows="8" units="Duty Cycle %">
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsDutyLookup" rows="8" units="RPM">
         1500.0 
         2000.0 
         2500.0 
         3000.0 
         3500.0 
         4000.0 
         4500.0 
         5000.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsDutyLookup" rows="8" units="kpa">
         130.0 
         140.0 
         150.0 
         160.0 
         170.0 
         180.0 
         190.0 
         200.0 
      </constant>
        <constant name="boostControlEnable">"Baro"</constant>
        <constant name="unused15_1_1">"False"</constant>
        <constant name="unused15_1_2">"False"</constant>
        <constant name="unused15_1_3">"False"</constant>
        <constant digits="0" name="boostDCWhenDisabled" units="%">0.0</constant>
        <constant digits="0" name="boostControlEnableThreshold" units="kpa">255.0</constant>
        <constant cols="1" digits="0" name="unused15_3_176" rows="173" units="%">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
    </page>
    <settings Comment="These setting are only used if this msq is opened without a project.">
        <setting name="enablehardware_test_OFF" value="enablehardware_test_OFF"/>
        <setting name="NEW_COMMS" value="NEW_COMMS"/>
        <setting name="CAN_COMMANDS_OFF" value="CAN_COMMANDS_OFF"/>
        <setting name="CELSIUS" value="CELSIUS"/>
        <setting name="resetcontrol_standard" value="resetcontrol_standard"/>
        <setting name="LAMBDA" value="LAMBDA"/>
    </settings>
    <userComments Comment="These are user comments that can be related to a particular setting or dialog.">
        <userComment name="iacCrankDuty" value=""/>
        <userComment name="airDenRates" value=""/>
    </userComments>
</msq>
`